import { gql } from '@apollo/client';
import { surfaceUnionIdFragment } from 'graphql/surface-node/fragments/surface-node-fragment';

export const surfaceNodeAddedToProtocolSubscription = gql`
  subscription surfaceNodeAddedToProtocol($surface: ID!, $user: ID!) {
    surfaceNodeAddedToProtocol(surface: $surface, user: $user) {
      id
      isReference
      contains {
        ...surfaceNodeUnionId
      }
    }
  }
  ${surfaceUnionIdFragment}
`;
